import client from 'api/client';

export function setPasswordWithAuthCode(
    email: string,
    password: string,
    authentication_code: string
) {
    return client.post('/set_password_with_auth_code', { email, password, authentication_code });
}
